"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSdkApollo = void 0;
const validDocDefOps = ["mutation", "query", "subscription"];
const createSdkApollo = (getSdk) => function getSdkApollo(client) {
    const requester = async (doc, variables, options) => {
        // Valid document should contain *single* query or mutation unless it's has a fragment
        if (doc.definitions.filter((d) => d.kind === "OperationDefinition" &&
            validDocDefOps.includes(d.operation)).length !== 1) {
            throw new Error("DocumentNode passed to Apollo Client must contain single query or mutation");
        }
        const definition = doc.definitions[0];
        // Valid document should contain *OperationDefinition*
        if (definition.kind !== "OperationDefinition") {
            throw new Error("DocumentNode passed to Apollo Client must contain single query or mutation");
        }
        switch (definition.operation) {
            case "mutation": {
                const response = await client.mutate({
                    mutation: doc,
                    variables,
                    fetchPolicy: options?.fetchPolicy,
                    ...options,
                });
                if (response.errors) {
                    throw new Error(response.errors);
                }
                if (response.data === undefined || response.data === null) {
                    throw new Error("No data presented in the GraphQL response");
                }
                return response.data;
            }
            case "query": {
                const response = await client.query({
                    query: doc,
                    variables,
                    ...options,
                });
                if (response.errors) {
                    throw new Error(response.errors);
                }
                if (response.data === undefined || response.data === null) {
                    throw new Error("No data presented in the GraphQL response");
                }
                return response.data;
            }
            case "subscription": {
                throw new Error("Subscription requests through SDK interface are not supported");
            }
            default:
                throw new Error(`Unsupported operation ${definition.operation}`);
        }
    };
    return getSdk(requester); // TODO we need to revisit this
};
exports.createSdkApollo = createSdkApollo;
//# sourceMappingURL=createSdkApollo.js.map